import { getTextColor } from '../../theme/defaultThemeOperators';
export const getStatusTagBackgroundColor = getTextColor;